<template>
  <div class="main">
    <h2>404 <span>Page not found</span></h2>
    <div class="main__img">
      <img src="" alt="" />
    </div>
  </div>
</template>

<style scoped></style>

<script>
export default {
  name: "exError404",
};
</script>
